export default __webpack_public_path__ + "fonts/9edcf71fc863b9ac1cc118a5d10f56bd.svg";